import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FontAwesomeIcon from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    ACCOUNT,
    CONFIGURATION,
    EMPLOYEES,
    MENU_NS,
    PRODUCTS,
    PRODUCT_CATEGORIES,
    STORE_CLOSING,
    TABLES
} from './Constants';

const HeaderMenu: React.FC = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const { t } = useTranslation();

    const handleClick = React.useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        },
        [setAnchorEl]
    );

    const handleClose = React.useCallback(() => {
        setAnchorEl(null);
    }, [setAnchorEl]);

    const handleMenuItemClick = React.useCallback(() => {
        setAnchorEl(null);
    }, [setAnchorEl]);

    return (
        <div>
            <FontAwesomeIcon
                id='menu-dropdown'
                aria-controls='menu'
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                name='bars'
                className='menu-icon'
                onClick={handleClick}
            />
            <Menu
                id='menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'menu-dropdown' }}>
                <Link className='link' to={PRODUCT_CATEGORIES}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        {t(`${MENU_NS}.product_categories`)}
                    </MenuItem>
                </Link>
                <Link className='link' to={PRODUCTS}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        {t(`${MENU_NS}.products`)}
                    </MenuItem>
                </Link>
                <Link className='link' to={TABLES}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        {t(`${MENU_NS}.tables`)}
                    </MenuItem>
                </Link>
                <Link className='link' to={EMPLOYEES}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        {t(`${MENU_NS}.employees`)}
                    </MenuItem>
                </Link>
                <Link className='link' to={CONFIGURATION}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        {t(`${MENU_NS}.store_configuration`)}
                    </MenuItem>
                </Link>
                <Link className='link' to={ACCOUNT}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        {t(`${MENU_NS}.account_configuration`)}
                    </MenuItem>
                </Link>
                <Link className='link' to={STORE_CLOSING}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        {t(`${MENU_NS}.store_closing`)}
                    </MenuItem>
                </Link>
            </Menu>
        </div>
    );
};

export default HeaderMenu;
